var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportAnalyser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_487_4359)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.938105 15.0026H4.72805C5.18587 15.0026 5.57593 14.6719 5.65281 14.2215C6.49338 9.24119 10.7659 5.62615 15.8103 5.62615C17.9539 5.62615 20.0168 6.28906 21.7759 7.54263C22.1495 7.80729 22.6586 7.76697 22.9827 7.44192L25.6619 4.76177C26.0573 4.36646 26.0236 3.7088 25.5741 3.35806C22.7474 1.16135 19.3714 0.000305176 15.8103 0.000305176C7.79464 0.000305176 1.00036 5.99696 0.00777763 13.9487C-0.0629205 14.5067 0.372957 15.0026 0.938105 15.0026ZM16.9978 31.0624V27.2725C16.9978 26.8147 17.3284 26.4246 17.7789 26.3477C22.7592 25.5071 26.3742 21.2346 26.3742 16.1902C26.3742 14.0466 25.7113 11.9836 24.4577 10.2246C24.1922 9.85193 24.2343 9.34097 24.5584 9.01774L27.2386 6.33852C27.6288 5.94828 28.2886 5.97303 28.6423 6.42641C30.839 9.25309 32.0001 12.6292 32.0001 16.1901C32.0001 24.2058 26.0033 31.0001 18.0517 31.9927C17.4751 32.0615 16.9978 31.6136 16.9978 31.0624ZM13.8185 31.9919C6.58934 31.0881 0.910364 25.4091 0.0075406 18.1818C-0.06322 17.6234 0.373033 17.1279 0.937868 17.1279H4.72781C5.18563 17.1279 5.57569 17.4584 5.65264 17.9089C6.3815 22.2254 9.7722 25.617 14.0914 26.3468C14.5419 26.4236 14.8725 26.8138 14.8725 27.2716V31.0615C14.8724 31.6192 14.389 32.0597 13.8185 31.9919Z",
    fill: "url(#paint0_linear_487_4359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2471 12.2522C12.2471 11.7343 11.8273 11.3145 11.3095 11.3145H9.43422C8.9164 11.3145 8.49658 11.7343 8.49658 12.2522V19.7533C8.49658 20.2711 8.9164 20.6909 9.43422 20.6909H11.3095C11.8273 20.6909 12.2471 20.2711 12.2471 19.7533V12.2522Z",
    fill: "#603CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8726 19.7533V10.3769C17.8726 9.85902 17.4528 9.43921 16.935 9.43921H15.0597C14.5419 9.43921 14.1221 9.85902 14.1221 10.3769V19.7533C14.1221 20.2711 14.5419 20.6909 15.0597 20.6909H16.935C17.4529 20.6909 17.8726 20.2711 17.8726 19.7533Z",
    fill: "#603CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4986 19.7533V16.0027C23.4986 15.4849 23.0788 15.0651 22.561 15.0651H20.6857C20.1679 15.0651 19.748 15.4849 19.748 16.0027V19.7533C19.748 20.2711 20.1679 20.6909 20.6857 20.6909H22.561C23.0789 20.6909 23.4986 20.2711 23.4986 19.7533Z",
    fill: "#603CFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_487_4359",
    x1: 16,
    y1: -10.5,
    x2: 16,
    y2: 31.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8585EC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_487_4359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportAnalyser);
export default __webpack_public_path__ + "static/media/report_analyser.b7149842057e3bce3e45f0efda258717.svg";
export { ForwardRef as ReactComponent };